<template>
  <div class="log-oppea-box">
    <div class="item">操作用户：{{rowItem.operatedUserPO && rowItem.operatedUserPO.realName}}</div>
    <div class="item">被操作对象：{{form && form.updateTag}}</div>
    <div class="item">修改时间：{{rowItem.operatedTime}}</div>
    <el-row v-if="form">
      <el-col :span="12" v-if="form.beforeStr">
        <div class="grid-content">
          <div class="title">变更前</div>
          <template v-if="form.beforeStr.userMap">
            <div class="item">头像：<el-image style="width: 50px; height: 50px" :src="form.beforeStr.userMap.head_img" :preview-src-list="[form.beforeStr.userMap.head_img]"></el-image></div>
            <div class="item">登录账号：{{form.beforeStr.userMap.user_name}}</div>
            <div class="item">手机号：{{form.beforeStr.userMap.user_pho}}</div>
          </template>
          <template v-if="form.beforeStr.staffMap">
            <div class="item">姓名：{{form.beforeStr.staffMap.real_name}}</div>
            <div class="item">性别：{{form.beforeStr.staffMap.sex === 1?'男':(form.beforeStr.staffMap.sex === 2?'女':'')}}</div>
            <div class="item">工作状态：{{form.beforeStr.staffMap.work_status === 10?'在线':(form.beforeStr.staffMap.work_status === 20?'离线':'离开')}}</div>
          </template>

        </div>
      </el-col>
      <el-col :span="12" v-if="form.afterStr ">
        <div class="grid-content log-line">
          <div class="title">变更后</div>
          <template v-if="form.afterStr.userMap">
            <div class="item">头像：<el-image style="width: 50px; height: 50px" :src="form.afterStr.userMap.head_img" :preview-src-list="[form.afterStr.userMap.head_img]"></el-image></div>
            <div class="item">登录账号：{{form.afterStr.userMap.user_name}}</div>
            <div class="item">手机号：{{form.afterStr.userMap.user_pho}}</div>
          </template>
          <template v-if="form.afterStr.staffMap">
            <div class="item">姓名：{{form.afterStr.staffMap.real_name}}</div>
            <div class="item">性别：{{form.afterStr.staffMap.sex === 1?'男':(form.afterStr.staffMap.sex === 2?'女':'')}}</div>
            <div class="item">工作状态：{{form.afterStr.staffMap.work_status === 10?'在线':(form.afterStr.staffMap.work_status === 20?'离线':'离开')}}</div>
          </template>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import sysDataCompareLogApi from '@/api/log/sysDataCompareLog'
export default {
  props: ['rowItem'],
  data() {
    return {
      form: null
    }
  },
  created() {
    this.getLogShow()
  },
  methods: {
    getLogShow() {
      sysDataCompareLogApi.fetchById(this.rowItem.id).then(res => {
        this.form = res.data;

      })
    }
  }

}
</script>

<style lang="scss" scoped>
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
</style>
